<template>
  <div class="index">
    <el-row class="row-box">
      <el-col :span="10" class="left">
        <div class="form" style="text-align:left;margin-top:10px;padding-left:20px">
          <span>选择专业：</span>
          <el-select v-model="professionId" placeholder="请选择" size="medium" @change="selectData" style="width:calc(100% - 192px)">
            <el-option
              v-for="item in professionData"
              :key="item.id"
              :label="item.dictionaryName"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="block left-block" v-if="data.length">
          <!-- :default-checked-keys="[data[0].id]" -->
          <!-- :current-node-key="currentNodeKey"  -->
          <el-tree
          ref="tree"
          :data="data"
          node-key="id"
          :highlight-current="true"
          :current-node-key="currentNodeKey"
          :expand-on-click-node="true"
          :check-on-click-node="true"
          :indent="30"
          :filter-node-method="filterNode"
          :accordion="true"
          :props="{
            label: 'name',
            children: 'subList'
          }"
          @node-click="nodeClick"
          :default-expanded-keys="defaultExpandIds"
          @node-expand="handleNodeExpand"
        >
          <div class="custom-tree-node" slot-scope="{ node, data }">
            <div style="display: flex">
              <span class="level-path">{{data.levelPath}}</span>
              <span style="margin-left: 5px;display: inline-block;">{{data.name}}</span>
            </div>
            <span style="margin-left:20px;margin-top: 5px;">
              <el-button type="text" size="mini" @click.stop="() => edit(data, node)">编辑</el-button>
            </span>
          </div>
        </el-tree>
      </div>
      <el-empty v-else description="暂无数据"></el-empty>
      <div style="padding: 12px 0;text-align:left;padding-left:20px">
        <el-button type="primary" size="small" @click="handleSet">批量设置</el-button>
      </div>
      </el-col>
      <el-col :span="14" class="right" v-loading="loading">
        <div class="block">
          <tab-button
          :showAll="false"
          :tabs="baseMenu"
          :label="'题目类型'"
          :prop="'type'"
          :initialTab="1"
          @tab-change="onTabChange"
        />
        <el-button icon="" type="text" size="medium" @click="getRightData(directoryId)">刷新</el-button>
        </div>
        <div style="text-align: left;padding-left: 30px;margin-bottom:10px" v-if="type!=3">
          <span>是否设为任务点：</span>
          <el-radio v-model="task" :label="1" @change="setTask">是</el-radio>
          <el-radio v-model="task" :label="0" @change="setTask">否</el-radio>
        </div>
        <!-- <div class="context">
          <p class="text">资源信息</p>
          <question v-if="type==1&&questions.length" :questions="questions" @update="getRightData(directoryId)" :isEdit="isEdit" />
          <vedio v-if="type==2&&vedios.length" :vedios="vedios" @update="getRightData(directoryId)" :videoUrl="videoUrl" :isEdit="isEdit" />
          <courseware ref="courseware" v-if="type==3&&coursewares.length" :coursewares="coursewares" @update="getRightData(directoryId)" :coursewareUrl="coursewareUrl" :isEdit="isEdit" />
          <casebox v-if="type==4&&cases.length" :cases="cases" @update="getRightData(directoryId)" :isEdit="isEdit" />
          <el-empty v-if="type==1&&!questions.length||type==2&&!vedios.length||type==3&&!coursewares.length||type==4&&!cases.length" description="暂无数据"></el-empty>
        </div> -->
        <!-- <div class="context">
          <p class="text">资源信息</p>
          <RecycleScroller
            v-if="type === 1 && visibleQuestions.length"
            class="scroller"
            :items="visibleQuestions"
            page-mode
            :min-item-size="200"
            :item-size="null"
            :buffer="1200"
            key-field="id"
            v-slot="{ item }"
          >
            <div :key="item.id" class="dynamic-item">
              <question :questions="[item]" @update="getRightData(directoryId)" :isEdit="isEdit" />
            </div>
          </RecycleScroller>
          <RecycleScroller
            v-if="type === 2 && visibleVedios.length"
            class="scroller"
            :items="visibleVedios"
            page-mode
            :min-item-size="200"
            :item-size="null"
            :buffer="1200"
            key-field="id"
            v-slot="{ item }"
          >
            <vedio :vedios="[item]" @update="getRightData(directoryId)" :videoUrl="videoUrl" :isEdit="isEdit" />
          </RecycleScroller>
          <RecycleScroller
            v-if="type === 3 && visibleCoursewares.length"
            class="scroller"
            :items="visibleCoursewares"
            :item-size="50"
            key-field="id"
            v-slot="{ item }"
          >
            <courseware ref="courseware" :coursewares="[item]" @update="getRightData(directoryId)" :coursewareUrl="coursewareUrl" :isEdit="isEdit" />
          </RecycleScroller>
          <RecycleScroller
            v-if="type === 4 && visibleCases.length"
            class="scroller"
            :items="visibleCases"
            :item-size="50"
            key-field="id"
            v-slot="{ item }"
          >
            <casebox :cases="[item]" @update="getRightData(directoryId)" :isEdit="isEdit" />
          </RecycleScroller>
          <el-empty v-if="type === 1 && !visibleQuestions.length || type === 2 && !visibleVedios.length || type === 3 && !visibleCoursewares.length || type === 4 && !visibleCases.length" description="暂无数据"></el-empty>
          <div v-if="isLoading" class="loading-indicator">加载中...</div>
        </div> -->
        <div class="context">
          <p class="text">资源信息</p>
          <question v-if="type === 1" :questions="visibleQuestions" @update="getRightData(directoryId)" :isEdit="isEdit" />
          <vedio v-if="type === 2 && vedios.length" :vedios="visibleVedios" @update="getRightData(directoryId)" :videoUrl="videoUrl" :isEdit="isEdit" />
          <courseware ref="courseware" v-if="type === 3 && coursewares.length" :coursewares="visibleCoursewares" @update="getRightData(directoryId)" :coursewareUrl="coursewareUrl" :isEdit="isEdit" />
          <!-- <RecycleScroller
            v-if="type === 3 && visibleCoursewares.length"
            class="scroller"
            :items="visibleCoursewares"
            :item-size="50"
            key-field="id"
            v-slot="{ item }"
          >
            <courseware ref="courseware" :coursewares="[item]" @update="getRightData(directoryId)" :coursewareUrl="coursewareUrl" :isEdit="isEdit" />
          </RecycleScroller> -->
          <casebox v-if="type === 4 && cases.length" :cases="visibleCases" @update="getRightData(directoryId)" :isEdit="isEdit" />
          <!-- 添加加载指示器 -->
          <el-empty v-if="type === 1 && !visibleQuestions.length || type === 2 && !visibleVedios.length || type === 3 && !visibleCoursewares.length || type === 4 && !visibleCases.length" description="暂无数据"></el-empty>
          <div v-if="isLoading" class="loading-indicator">加载中...</div>
        </div>
      </el-col>
    </el-row>
    <settings ref="settings" @update="selectData"
    :data="data" :dialogsettings.sync="dialogsettings" :professionId="professionId" />
  </div>
</template>

<script>
import { courseServer, packgeServer, keyServer } from '@/api/api'
import { baseMenu } from '@/data/data';
import tabButton from '@/mixin/table.js';
import question from './components/question.vue'
import vedio from './components/vedio.vue'
import courseware from './components/courseware.vue'
import casebox from './components/casebox.vue'
import settings from './components/settings.vue'
import { RecycleScroller } from 'vue-virtual-scroller'
export default {
  mixins: [tabButton],
  components: {question, vedio, courseware, casebox, settings, RecycleScroller},
  data () {
    const data = [];
    return {
      baseMenu,
      loading: false,
      defaultExpandIds: [],  // 用于记录展开的节点
      data: JSON.parse(JSON.stringify(data)),
      task: 1,
      directoryId: null,
      currentNode: null,
      currentNodeKey: null,
      professionData: [],
      professionId: '',
      professionName: '',
      questions: [],
      vedios: [],
      videoUrl: {},
      coursewares: [],
      coursewareUrl: {},
      cases: [],
      isEdit: false,
      type: 1,
      chunkSize: 1, // 每次渲染的数据量
      timer: null,
      visibleQuestions: [], // 补充可见问题数据
      visibleVedios: [],    // 补充可见视频数据
      visibleCoursewares: [], // 补充可见课件数据
      visibleCases: [],      // 补充可见案例数据
      // 新增加载状态
      isLoading: false,
      // 添加标识位，防止重复加载
      isLoadingData: false,
      dialogsettings: false
    }
  },
  watch: {
    type: {
      handler(newVal) {
        if (!this.isLoadingData) {
          this.resetVisibleData();
          this.loadDataInChunks(newVal);
        }
      },
      immediate: true
    },
    questions: {
      handler(newVal) {
        if (this.type === 1 && !this.isLoadingData) {
          this.resetVisibleData();
          this.loadDataInChunks(this.type);
        }
      },
      deep: true
    },
    vedios: {
      handler(newVal) {
        if (this.type === 2 && !this.isLoadingData) {
          this.resetVisibleData();
          this.loadDataInChunks(this.type);
        }
      },
      deep: true
    },
    coursewares: {
      handler(newVal) {
        if (this.type === 3 && !this.isLoadingData) {
          this.resetVisibleData();
          this.loadDataInChunks(this.type);
        }
      },
      deep: true
    },
    cases: {
      handler(newVal) {
        if (this.type === 4 && !this.isLoadingData) {
          this.resetVisibleData();
          this.loadDataInChunks(this.type);
        }
      },
      deep: true
    }
  },
  created () {
    this.initData()
  },
  methods: {
    async initData() {
      try {
        await this.selectDataV1();
        this.selectData();
      } catch (error) {
        console.error('数据初始化失败:', error);
      }
    },
    handleSet () {
      this.dialogsettings = true
      this.$refs.settings.initForm()
    },
    questionData (directoryId) {
      this.loading = true
      this.questions = []
      packgeServer.questions({
        directoryId,
        professionId: this.professionId
      }).then(res => {
        const {code, data, message} = res
        this.loading = false
        if (code === '0') {
          data.forEach(v => {
            if (v.type !== 3 || v.type !== 5) v.options = JSON.parse(v.options)
            if (v.type === 5) v.answer = JSON.parse(v.answer)
          })
          this.questions = data
        } else {
          this.$message.error(message)
        }
      }).catch((error) => {
        this.$message.error(error)
      })
    },
    vedioData (directoryId) {
      this.loading = true
      this.vedios = []
      packgeServer.vedios({
        directoryId,
        professionId: this.professionId
      }).then(res => {
        const {code, data, message} = res
        this.loading = false
        if (code === '0') {
          this.vedios = data
          const videoUrlObj = {}
          const filePaths = []
          data.forEach(v => {
            if (v.source === 1 || v.externalUrl) {
              videoUrlObj[v.filePath] = v.externalUrl
            } else {
              filePaths.push(v.filePath)
            }
          })
          this.videoUrl = videoUrlObj
          if (filePaths.length > 0) {
            const filePath = filePaths.join()
            this.getfileurl(filePath)
          }
        } else {
          this.$message.error(message)
        }
      }).catch((error) => {
        this.$message.error(error)
      })
    },
    coursewareData (directoryId) {
      this.loading = true
      this.coursewares = []
      packgeServer.coursewares({
        directoryId,
        professionId: this.professionId
      }).then(res => {
        const {code, data, message} = res
        this.loading = false
        if (code === '0') {
          this.coursewares = data
          const filePath = data.map(v => v.filePath).join()
          this.getfileurl(filePath)
        } else {
          this.$message.error(message)
        }
      }).catch((error) => {
        this.$message.error(error)
      })
    },
    caseData (directoryId) {
      this.loading = true
      this.cases = []
      packgeServer.cases({
        directoryId,
        professionId: this.professionId
      }).then(res => {
        const {code, data, message} = res
        this.loading = false
        if (code === '0') {
          this.cases = data
        } else {
          this.$message.error(message)
        }
      }).catch((error) => {
        this.$message.error(error)
      })
    },
    getRightData (directoryId) {
      if (this.type === 1) {
        this.questionData(directoryId)
      }
      if (this.type === 2) {
        this.vedioData(directoryId)
      }
      if (this.type === 3) {
        this.coursewareData(directoryId)
      }
      if (this.type === 4) {
        this.caseData(directoryId)
      }
    },
    nodeClick (data, node, current) {
      this.currentNode = data
      this.directoryId = data.id
      this.defaultExpandIds = [data.id]
      this.getTaskFlag()
      this.isEdit = false
      this.getRightData(data.id)
    },
    edit (data, node) {
      this.isEdit = true
    },
    // 处理 tab 切换事件
    onTabChange({tab, prop}) {
      this[prop] = tab
      courseServer.courseDirectoryList({
        professionId: this.professionId
      }).then(res => {
        const {code, data, message} = res
        if (code === '0') {
          this.data = data
          this.currentNodeKey = this.directoryId
          this.getTaskFlag()
          this.$nextTick(() => {
            this.$refs['tree'].setCurrentKey(this.currentNodeKey)
          })
        } else {
          this.$message.error(message)
        }
      }).catch((error) => {
        this.$message.error(error)
      })
      this.getRightData(this.directoryId)
      // 这里可以根据不同的 tab 索引进行相应的操作
    },
    setTask () {
      let prop = this.type === 1 ? 'questionTask' : this.type === 2 ? 'vedioTask' : this.type === 3 ? 'coursewareTask' : 'studyTask'
      courseServer.courseDirectorySet({
        directoryId: this.directoryId,
        professionId: this.professionId,
        [prop]: this.task,
      }).then(res => {
        const {code, message} = res
        if (code) {
          this.$message.success('设置成功')
        } else {
          this.$message.error(message)
        }
      }).catch((error) => {
        this.$message.error(error)
      })
    },
    selectData () {
      courseServer.courseDirectoryList({
        professionId: this.professionId
      }).then(res => {
        const {code, data, message} = res
        if (code === '0') {
          this.data = data
          if (data.length) {
            this.directoryId = data[0].id
            this.currentNodeKey = data[0].id
            this.getTaskFlag()
            this.$nextTick(() => {
              this.$refs['tree'].setCurrentKey(this.currentNodeKey)
            })
            this.getRightData(this.directoryId)
          } else {
            this.questions = []
            this.vedios = []
            this.coursewares = []
            this.cases = []
          }
        } else {
          this.$message.error(message)
        }
      }).catch((error) => {
        this.$message.error(error)
      })
    },
    // 专业数据
    selectDataV1 () {
      return new Promise((resolve, reject) => {
        keyServer.profession({
          dictionaryKey: 'profession'
        }).then(res => {
          const {code, data, message} = res
          if (code === '0') {
            this.professionData = data
            this.professionId = this.professionData[0].id
            this.professionName = this.professionData[0].dictionaryName
            resolve();
          } else {
            this.$message.error(message)
            reject(new Error(message));
          }
        }).catch((error) => {
          this.$message.error(error)
          reject(error);
        })
      });
    },
    getTaskFlag () {
      let currentData = this.currentNode ? this.currentNode : this.data.filter(v => v.id === this.directoryId)[0]
      // console.log(this.currentNode, 'currentNode')
      // console.log(this.data, '---')
      // console.log(this.data.filter(v => v.id === this.directoryId), 'this.data')
      // console.log(this.directoryId, 'this.directoryId')
      // console.log(currentData, 'currentData')
      // return
      if (this.type === 1) this.task = currentData.questionTask
      if (this.type === 2) this.task = currentData.vedioTask
      if (this.type === 3) this.task = currentData.coursewareTask
      if (this.type === 4) this.task = currentData.studyTask
    },
    resetVisibleData() {
      this.visibleQuestions = [];
      this.visibleVedios = [];
      this.visibleCoursewares = [];
      this.visibleCases = [];
    },
    loadDataInChunks(type) {
      // 清空之前的定时器
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      let sourceData = [];
      let targetKey = '';
      switch (type) {
        case 1:
          sourceData = this.questions;
          targetKey = 'visibleQuestions';
          break;
        case 2:
          sourceData = this.vedios;
          targetKey = 'visibleVedios';
          break;
        case 3:
          sourceData = this.coursewares;
          targetKey = 'visibleCoursewares';
          break;
        case 4:
          sourceData = this.cases;
          targetKey = 'visibleCases';
          break;
      }
      let index = 0;
      this.isLoading = true;
      this.isLoadingData = true;
      const loadChunk = () => {
        // 计算本次要加载的数据块
        const chunk = sourceData.slice(index, index + this.chunkSize);
        // 使用 Vue 的响应式更新方式更新数据
        this[targetKey] = [...this[targetKey], ...chunk];
        index += this.chunkSize;
        if (index < sourceData.length) {
          // 使用 setTimeout 增加分步间隔时间
          this.timer = setTimeout(loadChunk, 100);
        } else {
          this.isLoading = false;
          this.isLoadingData = false;
        }
        console.log(this.visibleVedios, 'visibleVedios')
        console.log(this.vedios, 'vedios')
      };
      loadChunk();
    },
    // 树节点展开
    handleNodeExpand(data) {
      // 保存当前展开的节点
      let flag = false
      this.defaultExpandIds.some(item => {
        if (item === data.id) { // 判断当前节点是否存在， 存在不做处理
          flag = true
          return true
        }
      })
      if (!flag) { // 不存在则存到数组里
        this.defaultExpandIds = [data.id]
      }
      console.log(this.defaultExpandIds, 'this.defaultExpandIds')
    },
    getfileurl (fileKeys) {
      this.$getUrl({
      fileKeys
      }).then(obj => {
        if (obj) {
          if (this.type === 2) {
            this.videoUrl = { ...this.videoUrl, ...obj }
          }
          if (this.type === 3) {
            this.coursewareUrl = { ...this.coursewareUrl, ...obj }
          }
        }
      })
    },
    filterNode (value, data) {
      return !data.delete;
    }
  },
  beforeUnmount() {
    if (this.timer) {
      cancelAnimationFrame(this.timer);
    }
  }
}
</script>

<style lang='scss' scoped>
.loading-indicator {
  text-align: center;
  padding: 10px;
  color: #666;
}
.index {
  margin: 0 10px;
  .form {
    /deep/ .el-input__inner {
      font-family: PingFang SC;
      // height: 32px;
      border-radius: 8px;
      border: 1px solid #D0DFFB;
      // color: #AAB4D2;
    }
    /deep/ .el-select, /deep/ .el-cascader {
      .el-input__inner {
        border-radius: 4px;
        color: #4F6389;
      }
    }
  }
}
.row-box {
  display: flex;
  align-self: baseline;
}
.left {
  margin-right: 16px;
  max-height: calc(100vh - 70px);
  overflow: auto;
}
.left, .right {
  border-radius: 8px;
  background: #fff;
  overflow: auto;
  box-shadow: 0px 1px 4px 0px rgba(30, 155, 255, 0.3);
}
.block {
  padding: 10px;
  // height: 100%;
  // align-self: baseline;
  display: flex;
  justify-content: space-between;
  padding-right: 8px;
  .custom-tree-node {
    width: 100%;
    display: flex;
    align-items: baseline;
    text-align: left;
  }
  .level-path {
    display: inline-block;
    align-self: center;
    // width: 20px;
  }
}
.context {
  padding: 10px 30px;
  max-height: calc(100vh - 160px);
  overflow: auto;
  padding-right: 10px;
  margin-right: 8px;
  .text {
    text-align: left;
    font-weight: 600;
    font-size: 16px;
  }
}

/* 为虚拟滚动组件添加样式 */
.scroller {
  height: 100%; /* 必须指定高度 */
}

.dynamic-item {
  /* 确保项目是块级元素且可以自动撑开 */
  display: block;
  width: 100%;
}

</style>
<style lang='scss'>
.block .el-tree {
  width: 100%;
}
.left-block .el-tree {
  height: calc(100vh - 196px);
  overflow: auto;
  padding-right: 8px;
  margin-right: -8px;
}
.block .el-tree .el-tree-node {
  white-space: normal !important;
  line-height: 20px;
  // overflow: hidden;
  // text-overflow: ellipsis;
}
.el-tree-node,
.el-tree-node__content {
  margin-bottom: 5px;
  min-height: 50px;
  // max-height: 65px;
  height: auto;
  border-radius: 6px;
}
.el-icon-caret-right{
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/coursePackage/commonPackage.vue